import React, { useEffect, useState } from "react";
import Layout from "../Component/Layout";
// import GolfImage from "../assets/Image/1.png";
// import GolfImage1 from "../assets/Image/2.png";
// import Instagram from "../assets/Image/instagram.png";
import { BiMap } from "react-icons/bi";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useSavedEvents } from "../context/SavedEventContext";
import { useParams } from "react-router-dom";

const UserEvents = () => {
  const { id: userId, eventId } = useParams();
  const {
    savedEvents,
    loading: eventLoading,
    fetchSavedEvents,
  } = useSavedEvents();

  const [eventDetail, setEventDetail] = useState(null);
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    const loadEvent = async () => {
      setLocalLoading(true);

      let events = savedEvents;

      // If no events are loaded yet, fetch them
      if (!eventLoading && savedEvents.length === 0) {
        events = await fetchSavedEvents(userId);
      }

      if (eventId && events?.length > 0) {
        const found = events.find((e) => String(e.id) === String(eventId));
        setEventDetail(found || null);
      }

      setLocalLoading(false);
    };

    loadEvent();
  }, [eventId, userId, savedEvents.length]);

  if (!eventDetail && !eventLoading) return <p>No event selected or found.</p>;
  if (!eventDetail || eventLoading) return <p>Loading event details...</p>;

  return (
    <Layout>
      <Link to={`/users/detail/${userId}`} className="btn btn-primary mb-4">
        Back
      </Link>

      <div className="row row-cols-1 row-cols-md-3 g-6 mb-12">
        <div className="col-lg-4 col-md-5">
          <div className="card">
            {eventDetail ? (
              <>
                <div className="card-body p-5">
                  <div className="position-relative">
                    <img
                      className="card-img-top"
                      src={eventDetail.thumbnail}
                      alt="Course"
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <h5 className="card-title m-0">{eventDetail.trip_name}</h5>
                    {/* <p className="m-0 text-dark fw-medium">
                      ({eventDetail.type})
                    </p> */}
                  </div>
                  <p className="card-text mb-2">{eventDetail.description}</p>
                  <p className="card-text">
                    <BiMap className="bx" />
                    {eventDetail.location}
                  </p>
                </div>
              </>
            ) : (
              <p>Loading event details...</p>
            )}

            {/* <Swiper
              className="userevents"
              navigation={true} // Enable navigation
              modules={[Navigation]}
              spaceBetween={10}
              breakpoints={{ 0: { slidesPerView: 1 } }}
            >
              {CourseImage.map((img, index) => (
                <SwiperSlide className="position-relative" key={index}>
                  <img className="card-img-top" src={img.images} alt="Course" />
                </SwiperSlide>
              ))}
            </Swiper> */}

            {/* {Plans.map((item, index) => (
              <div className="card-body p-5" key={index}>
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <h5 className="card-title m-0">{item.title}</h5>
                  <p className="m-0 text-dark fw-medium">({item.type})</p>
                </div>
                <p className="card-text mb-2">{item.description}</p>
                <p className="card-text">
                  <BiMap className="bx" />
                  {item.location}
                </p>
              </div>
            ))} */}
          </div>
        </div>

        <div className="col-lg-8 col-md-7">
          <div className="card">
            <div className="card-body">
              {eventDetail && (
                <div className="stay mb-5">
                  <h5 className="mb-2">Clubs</h5>
                  <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                    {(eventDetail.clubs || []).map((course, index) => (
                      <li className="light-bg" key={index}>
                        {course.coursename}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {eventDetail && (
                <div className="stay mb-5">
                  <h5 className="mb-2">Stays</h5>
                  <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                    {eventDetail.stays.map((stay, index) => (
                      <li className="light-bg" key={index}>
                        {stay.stayname}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {eventDetail && (
                <div className="stay mb-5">
                  <h5 className="mb-2">Additional Activities</h5>
                  <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                    {eventDetail.activity.map((activity, index) => (
                      <li className="light-bg" key={index}>
                        {activity.activityname}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {eventDetail && (
                <div className="stay mb-5">
                  <h5 className="mb-2">Social Links</h5>
                  <ul className="p-0 m-0 d-flex flex-wrap gap-3 align-items-start">
                    {eventDetail.socialLinks.map((links, index) => (
                      <li className="light-bg" key={index}>
                        <img
                          src={links.img}
                          className="me-2"
                          alt=""
                          width={22}
                          height={22}
                        />
                        <a
                          href={links.activityname}
                          style={{ color: "#646e78" }}
                        >
                          {links.activityname}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserEvents;
